var bankValues = {
    heading: {
        xs: {
            size: 20,
            lineHeight: 28,
        },
        sm: {
            size: 24,
            lineHeight: 32,
        },
        md: {
            size: 30,
            lineHeight: 40,
        },
        lg: {
            size: 36,
            lineHeight: 48,
        },
        xl: {
            size: 48,
            lineHeight: 64,
        },
    },
    body: {
        xs: {
            size: 12,
            lineHeight: 16,
        },
        sm: {
            size: 14,
            lineHeight: 20,
        },
        md: {
            size: 16,
            lineHeight: 24,
        },
        lg: {
            size: 20,
            lineHeight: 28,
        },
        xl: {
            size: 24,
            lineHeight: 32,
        },
    },
};
var getBaseFont = function (variant) {
    switch (variant) {
        case 'bank':
            return bankValues;
        default:
            return bankValues;
    }
};
var formatFontValues = function (target, baseFont) { return ({
    xs: {
        size: "".concat(baseFont[target].xs.size, "px"),
        lineHeight: "".concat(baseFont[target].xs.lineHeight, "px"),
    },
    sm: {
        size: "".concat(baseFont[target].sm.size, "px"),
        lineHeight: "".concat(baseFont[target].sm.lineHeight, "px"),
    },
    md: {
        size: "".concat(baseFont[target].md.size, "px"),
        lineHeight: "".concat(baseFont[target].md.lineHeight, "px"),
    },
    lg: {
        size: "".concat(baseFont[target].lg.size, "px"),
        lineHeight: "".concat(baseFont[target].lg.lineHeight, "px"),
    },
    xl: {
        size: "".concat(baseFont[target].xl.size, "px"),
        lineHeight: "".concat(baseFont[target].xl.lineHeight, "px"),
    },
}); };
var font = function (baseFont) { return ({
    heading: formatFontValues('heading', baseFont),
    body: formatFontValues('body', baseFont),
}); };
var getFont = function (variant) {
    return font(getBaseFont(variant));
};
export { getFont, getBaseFont };
//# sourceMappingURL=font.js.map